import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';

import { FullScreenLayout } from './';

const NoClient: FC = () => (
  <Grid container alignItems="center" justify="center">
    <Grid item>
      <FullScreenLayout
        message={
          <Typography variant="h2">
            <Trans i18nKey="components:404Client" />
          </Typography>
        }
      />
    </Grid>
  </Grid>
);

export default NoClient;
